// extracted by mini-css-extract-plugin
export default {"header-component-item-wrapper":"r9PPO_header-component-item-wrapper"};